// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"de741aa3","170":"44b8b50d","206":"56a3a5b5","239":"5ada3f48","462":"373cb190","822":"5a5b81c9"}[chunkId] + ".chunk.js";
};